import Barcode from 'react-barcode';

interface ChildProps{
    idGuiaProforma : number
    width: number
    heigth: number
}
const CodigoBarra: React.FC<ChildProps> = ({ idGuiaProforma, width, heigth }) => {
  return (
    <div className='pr'>
      <Barcode 
      value={idGuiaProforma.toString()} 
      width={width} 
      height={heigth}
      displayValue={false}
      />
    </div>
  );
};

export default CodigoBarra;